import createKeyFactory, { KEYS } from 'utils/createKeyFactory';

const illustrationsFactory = createKeyFactory([KEYS.ILLUSTRATIONS]);

export default illustrationsFactory;
